import { useQuery } from '@tanstack/react-query';
import { queryDefectsForWorkpacks } from '../../../services/api';
import { Defect } from '../../../models/defects';

const useQueryDefectsForWorkpacks = ({ id }: { id: string }): { data: Defect[]; isLoading: boolean } => {
  const { data, isLoading } = useQuery({
    queryKey: ['queryDefectsForWorkpacks', id],
    queryFn: () => {
      return queryDefectsForWorkpacks({ aircraft_id: id });
    },
    enabled: !!id,
  });

  return { data, isLoading };
};

export default useQueryDefectsForWorkpacks;
